module.exports = __webpack_public_path__ + "static/media/workimg.49f1d9af.webp";